import { useQuery } from '@apollo/client';
import { usePaginationAndFilter } from 'components/template/ListTemplate/hooks/usePaginationAndFilter';
import { GRAPHQL_BUSCAR_TAXAS } from 'gql/taxas';
import { useEffect, useMemo } from 'react';
import JSON_DATA_FILTER from '../../data/filter.json';
import { IQueryTaxas } from './index.d';

export const useQueryFilterTaxas = () => {
    const dataSelectHeader = useMemo(() => JSON_DATA_FILTER, []);

    const props = usePaginationAndFilter({
        dataKeyName: null,
        keysQueryVariavel: [],
    });

    const { loading } = useQuery<IQueryTaxas>(
        GRAPHQL_BUSCAR_TAXAS,
        {
            context: props.context,
            variables: props.variables,
            onCompleted: ({ taxas }) =>
                props.onCompleted(taxas),
            onError: props.onError,
        }
    );

    useEffect(() => {
        props.setLoading(loading);
    }, [loading]);

    return { ...props, dataSelectHeader };
};